import styles from './CreatedBy.module.css';

interface CreatedByProps {
  author: string;
}

function CreatedBy({ author }: CreatedByProps): JSX.Element {
  return (
    <div className={styles.creatorInfo}>
      <span>Created By: </span>
      <a href={`/users/${author}`} className={styles.creatorLink}>@{author}</a>
    </div>
  );
}

export default CreatedBy; 